module.exports = __webpack_public_path__ + "static/policy_book1_6-0c4b4a85ef668edfc2511d81696ffe56.png";